/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class MonitorService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  checkHealth(): Observable<unknown> {
    return this._httpClient.get<unknown>(
      `${this._apiConstantsService.monitorUrl}/health/checks`,
      {
        params: {
          initial: 1
        },
        withCredentials: true
      }
    );
  }
}
